import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllTypePaymentsUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllTypePayments/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllTypePaymentsUser = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllTypePaymentsUser;
};


const setActiveTypePayments = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setTypePaymentsActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllTypePaymentsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса TypePayments  - ',response);


    return AllTypePaymentsUser;
};



const setDeletedTypePayments = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setTypePaymentsDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllTypePaymentsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса TypePayments  - ',response);


    return AllTypePaymentsUser;
};




const setUpdateTypePayments = async (dataTypePaymentsUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setTypePaymentsUpdate/'),{
        dataTypePaymentsUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllTypePaymentsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса TypePayments  - ',response);


    return AllTypePaymentsUser;
};


const setSaveNewTypePayments = async (dataTypePaymentsUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewTypePayments/'),{
        dataTypePaymentsUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllTypePaymentsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса TypePayments  - ',response);


    return AllTypePaymentsUser;
};

Mock.onGet('/api/reference/getAllTypePayments').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllTypePaymentsUser = await getAllTypePaymentsUser();

    // if (!AllTypePaymentsUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllTypePaymentsUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllTypePaymentsUser,
    ]


})


Mock.onPost('/api/reference/setActiveTypePayments').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllTypePaymentsUser = await setActiveTypePayments(id,val);

    // if (!AllTypePaymentsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllTypePaymentsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllTypePaymentsUser,
    ]


})

Mock.onPost('/api/reference/setDeletedTypePayments').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllTypePaymentsUser = await setDeletedTypePayments(id,val);

    // if (!AllTypePaymentsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllTypePaymentsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllTypePaymentsUser,
    ]


})


Mock.onPost('/api/reference/setUpdateTypePayments').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataTypePaymentsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereTypePayments = await setUpdateTypePayments(dataTypePaymentsUpdate);

    // console.log('Серовер вернул данные ',AllTypePaymentsUser);

    // if (!refereTypePayments) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereTypePayments) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereTypePayments,
    ]


})


Mock.onPost('/api/reference/setSaveNewTypePayments').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataTypePaymentsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereTypePayments = await setSaveNewTypePayments(dataTypePaymentsUpdate);

    // console.log('Серовер вернул данные ',AllTypePaymentsUser);

    // if (!refereTypePayments) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereTypePayments) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereTypePayments,
    ]
})